import { render, staticRenderFns } from "./Workspace.vue?vue&type=template&id=377b19e2&scoped=true&"
import script from "./Workspace.vue?vue&type=script&lang=ts&"
export * from "./Workspace.vue?vue&type=script&lang=ts&"
import style0 from "./Workspace.vue?vue&type=style&index=0&id=377b19e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b19e2",
  null
  
)

export default component.exports